import { SoftwareVersions } from "components/ui/SoftwareVersions/SoftwareVersions"
import { H1 } from "components/ui/typography/titles/Titles"
import { useVersions } from "hooks/api/softwareVersion/softwareVersion.hook"
import style from "./Versions.module.scss"

const { title } = style

const appVersion = import.meta.env.VITE_APP_VERSION

export const Versions = () => {
	const { data: versions, isPending: isVersionsPending, isError: isVersionsError } = useVersions()

	return (
		<>
			<H1 className={title}>Stevens Inc. Archiscan</H1>
			<SoftwareVersions
				versions={versions}
				frontEndVersion={appVersion}
				isVersionsPending={isVersionsPending}
				isVersionsError={isVersionsError}
			/>
		</>
	)
}
